<template>
  <div class="relative w-full md:h-screen overflow-hidden flex items-center">
    <div class="container xl:max-w-[1440px] mx-auto flex gap-6 flex-col">
      <div class="flex justify-end items-center">
        <e-appearance
          color="neutral"
          variant="ghost"
        />
        <e-button
          color="neutral"
          icon="translate"
          variant="ghost"
        />
      </div>

      <section class="relative bg-(--color-card) rounded-2xl w-full py-20 px-4 md:p-20 mx-auto">
        <div class="absolute md:left-20 top-20 z-10">
          <e-logo
            class="w-[132px] h-auto"
            color="primary"
          />
        </div>
        <slot />
      </section>

      <div class="flex flex-wrap justify-between gap-4">
        <e-copyright class="text-xs text-primary" />
        <p class="text-xs">
          <slot name="trailing" />
        </p>
      </div>
    </div>
  </div>
</template>
